import { AppRouter } from './router/AppRouter';
import './App.css';
import { useInitializeConfig } from 'utilities/initializeConfig';
import { AuthProvider } from './auth/context/AuthProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DataProvider } from 'apollo/DataProvider';
import { FullPageLoader } from './components/loaderComponent';
import { UserIndicatorProvider } from './context/UserIndicatorContext';
import { ToastProvider } from './layout/ToastProvider';
import React from 'react';

function App() {
  const { loading, error } = useInitializeConfig();

  if (loading) {
    return <FullPageLoader />;
  }

  if (error) {
    return <div>Error loading configuration. Please try again later.</div>;
  }

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <ToastProvider>
        <DataProvider>
          <AuthProvider>
            <UserIndicatorProvider>
              <AppRouter />
            </UserIndicatorProvider>
          </AuthProvider>
        </DataProvider>
      </ToastProvider>
    </LocalizationProvider>
  );
}

export default App;
